import React from 'react';

import {
    Text,
    WDSModal,
} from 'wanderu-components';
import { localize } from 'wanderu-i18n';
import type { I18nMoneyFunction } from 'wanderu-i18n';

import { LineItem } from '../LineItem';
import { useItineraryInfoSelector } from '../hooks';
import { TripPriceDetails } from './TripPriceDetails';

import styles from './PriceBreakdownModal.scss';

import type { TFunction } from 'i18next';

interface PriceBreakdownModalProps {
    itineraryId: string;
    i18nMoney: I18nMoneyFunction;
    isOpen: boolean;
    onOpenChange: () => void;
    t: TFunction;
}

const PriceBreakdownModal = ({
    itineraryId = '',
    i18nMoney,
    isOpen,
    onOpenChange,
    t,
}: PriceBreakdownModalProps) => {
    const {
        outboundTrips,
        returnTripId,
        returnTrips,
        tripPricing,
    } = useItineraryInfoSelector(itineraryId);

    return (
        <WDSModal
            classes={{
                button: styles.button,
                dialog: styles.dialog,
                modal: styles.modal,
            }}
            isOpen={isOpen}
            onOpenChange={onOpenChange}
            title={t<string>('price-breakdown')}
            isDismissable
            showButton
        >
            <TripPriceDetails legs={outboundTrips} />

            {!!returnTripId && (
                <TripPriceDetails legs={returnTrips} isReturnTrip />
            )}

            <LineItem
                leftCol={<Text className={styles.left} variant="text-s" bold>{t<string>('tripTotal')}</Text>}
                rightCol={<Text className={styles.right} variant="text-s" bold>{i18nMoney.format(i18nMoney(tripPricing).getTotalPrice())}</Text>}
            />
        </WDSModal>
    );
};

export { PriceBreakdownModal };

export default localize(PriceBreakdownModal, ['i18nMoney', 't'], 'baseApp');
